// 출퇴근 화면의 IP 표기 유틸 (2026-09-14 분리)
//   목록 항목과 상단 카드가 같이 쓴다.

export function normalizeIp(ip) {
  if (!ip) return '-';
  return String(ip).replace(/^::ffff:/, '').trim();
}

/** '1.2.3.4 (별칭)' — 별칭이 없으면 IP 만. */
export function formatIpWithAlias(ip, alias) {
  const pureIp = normalizeIp(ip);
  const label = String(alias || '').trim();
  if (!pureIp || pureIp === '-') return '-';
  if (!label) return pureIp;
  return `${pureIp} (${label})`;
}
